import * as types from '../actions/actionTypes'

const initialState = {
    isLoading: false,
    artists: []
}

export default function artistsReducer(state = initialState, action) {
    switch (action.type) {
        case types.ARTISTS_IS_LOADING:
            return Object.assign({}, state, {
                isLoading: true
            })

        case types.ARTISTS_FETCH:
            return Object.assign({}, state, {
                artists: action.payload
            }) 

        case types.ARTISTS_ADD:
            return Object.assign({}, state, {
                artists: state.artists.concat(action.payload)
            })

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/artistsReducer.js